// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Core__Int = require("@rescript/core/src/Core__Int.res.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_cmp_settings = require("../ui/MM_cmp_settings.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Radio = require("@mui/material/Radio").default;
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var RadioGroup = require("@mui/material/RadioGroup").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function MM_cmp_pattern_search_params(props) {
  var onCancel = props.onCancel;
  var onOk = props.onOk;
  var highlightColor = props.highlightColor;
  var highlightMatchedSymbols = props.highlightMatchedSymbols;
  var patternVersion = props.patternVersion;
  var match = React.useState(function () {
        return patternVersion;
      });
  var setPatternVersion = match[1];
  var patternVersion$1 = match[0];
  var match$1 = React.useState(function () {
        return highlightMatchedSymbols;
      });
  var setHighlightMatchedSymbols = match$1[1];
  var highlightMatchedSymbols$1 = match$1[0];
  var match$2 = React.useState(function () {
        return highlightColor;
      });
  var setHighlightColor = match$2[1];
  var highlightColor$1 = match$2[0];
  var actOk = function () {
    onOk(patternVersion$1, highlightMatchedSymbols$1, highlightColor$1);
  };
  var highlightMatchedSymbolsFinal = patternVersion$1 !== 1 && highlightMatchedSymbols$1;
  return React.createElement(Expln_React_Column.make, {
              spacing: 1,
              children: Caml_option.some(null)
            }, React.createElement(Expln_React_Row.make, {
                  alignItems: "center",
                  children: Caml_option.some(null)
                }, "Pattern version", React.createElement(RadioGroup, {
                      value: String(patternVersion$1),
                      onChange: Expln_React_common.evt2str(function (str) {
                            setPatternVersion(function (param) {
                                  return Core__Option.getOr(Core__Int.fromString(str, undefined), 1);
                                });
                          }),
                      row: true,
                      children: Caml_option.some(null)
                    }, React.createElement(FormControlLabel, {
                          control: React.createElement(Radio, {}),
                          label: "1",
                          value: "1"
                        }), React.createElement(FormControlLabel, {
                          control: React.createElement(Radio, {}),
                          label: "2",
                          value: "2"
                        }))), React.createElement(Expln_React_Row.make, {
                  children: Caml_option.some(null)
                }, React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            disabled: patternVersion$1 === 1,
                            checked: highlightMatchedSymbolsFinal,
                            onChange: Expln_React_common.evt2bool(function (b) {
                                  setHighlightMatchedSymbols(function (param) {
                                        return b;
                                      });
                                })
                          }),
                      label: "Highlight matched symbols"
                    }), highlightMatchedSymbolsFinal ? MM_react_common.rndColorSelect(MM_cmp_settings.allColors, highlightColor$1, (function (newHighlightColor) {
                          setHighlightColor(function (param) {
                                return newHighlightColor;
                              });
                        }), "Color") : null), React.createElement(Expln_React_Row.make, {
                  alignItems: "center",
                  children: Caml_option.some(null)
                }, React.createElement(Button, {
                      onClick: (function (param) {
                          actOk();
                        }),
                      variant: "contained",
                      children: "Ok"
                    }), React.createElement(Button, {
                      onClick: (function (param) {
                          onCancel();
                        }),
                      children: "Cancel"
                    })));
}

var make = MM_cmp_pattern_search_params;

exports.make = make;
/* react Not a pure module */
